export function deliveryDayDifference(value, now = new Date()) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return NaN;
  const [year, month, day] = value.split('-').map(Number);
  const selected = new Date(Date.UTC(year, month - 1, day));
  if (selected.getUTCFullYear() !== year || selected.getUTCMonth() !== month - 1 || selected.getUTCDate() !== day) return NaN;
  return (selected.getTime() - Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000;
}

class RequestedDeliveryDate extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.addEventListener('change', () => this.update(), { signal });
    this.addEventListener('input', () => this.update(), { signal });
    this.closest('form').addEventListener('submit', (event) => {
      if (!this.validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { capture: true, signal });
    this.update();
  }

  disconnectedCallback() { this.controller?.abort(); }

  update() {
    const form = this.closest('form');
    const date = this.querySelector('input');
    const enabled = this.querySelector('select').value === 'yes';
    const now = new Date();
    date.min = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    date.disabled = !enabled;
    date.required = enabled;
    this.querySelector('[data-delivery-fields]').hidden = !enabled;
    const days = deliveryDayDifference(date.value, now);
    const invalid = !Number.isFinite(days) || days < 0;
    const urgent = enabled && !invalid && days < 15;
    date.setCustomValidity(enabled && invalid ? (date.value ? this.dataset.invalid : this.dataset.missing) : '');
    this.querySelector('[data-delivery-urgent]').hidden = !urgent;
    form.toggleAttribute('data-delivery-blocked', enabled && (invalid || urgent));
    form.toggleAttribute('data-delivery-urgent', urgent);
    const message = this.dataset.message.replace('{product}', this.dataset.product).replace('{date}', date.value).replace('{url}', this.dataset.url);
    this.querySelector('[data-delivery-whatsapp]').href = `https://wa.me/918141897676?text=${encodeURIComponent(message)}`;
    return !enabled || (!invalid && !urgent);
  }

  validate() {
    if (this.update()) return true;
    this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (this.closest('form').hasAttribute('data-delivery-urgent')) {
      this.querySelector('[data-delivery-whatsapp]').focus({ preventScroll: true });
    } else {
      this.querySelector('input').reportValidity();
    }
    return false;
  }
}

if (!customElements.get('requested-delivery-date')) customElements.define('requested-delivery-date', RequestedDeliveryDate);
